module.exports = __webpack_public_path__ + "icons/original/large/large-d4.08e21c2cf4f787a7913cc84db58777ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d4.png
// module id = D3DT
// module chunks = app